module.exports = __webpack_public_path__ + "f04506b17b5cf1963f1f6826a0b94b55.svg";